import styled from "styled-components";

const Footnote = styled.p`
  font-size: 1.2rem;
`;

export default Footnote;
